import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { getTokens } from '../../../firebase/authentication';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API,
});

const authLink = setContext(async (_, { headers }) => {
  const tokens = await getTokens();
  const pinCodeId = localStorage.getItem('pincodeid');
  return {
    headers: {
      ...headers,
      Authorization: tokens.token ? `Bearer ${tokens.token}` : undefined,
      PinCodeId: pinCodeId,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  // link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      MessageAppointment: {
        keyFields: [
          'id',
          'startTime',
          'endTime',
          'actionStatus',
          'type',
          'healthProfessional',
          ['id'],
          'healthProvider',
          ['id'],
        ],
      },
    },
  }),
  /* defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
    query: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
  }, */
});

export { client };
